import { apiClient, apiGet, apiPost, apiPut, apiDelete } from "@/lib/api/client";
import type { PaginatedParams, PaginatedResponse } from "@/lib/api/types";

const BASE = "/blogs";

export const blogsApi = {
  list: (params?: PaginatedParams & { category?: string; author?: string }) => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.perPage) searchParams.set("perPage", String(params.perPage));
    if (params?.sort) searchParams.set("sort", params.sort);
    if (params?.order) searchParams.set("order", params.order);
    if (params?.category) searchParams.set("category", params.category);
    if (params?.author) searchParams.set("author", params.author);
    return apiGet<PaginatedResponse<Record<string, unknown>>>(`${BASE}?${searchParams.toString()}`);
  },

  getById: (slug: string) => apiGet<{ blog: Record<string, unknown> }>(`${BASE}/${slug}`),

  create: (data: Record<string, unknown>) => apiPost<{ blog: Record<string, unknown> }>(BASE, data),

  update: (slug: string, data: Record<string, unknown>) =>
    apiPut<{ blog: Record<string, unknown> }>(`${BASE}/${slug}`, data),

  delete: (slug: string) => apiDelete<{ message: string }>(`${BASE}/${slug}`),

  getSeries: (slug: string) => apiGet<{ series: Record<string, unknown> }>(`${BASE}/series/${slug}`),

  getSeriesPosts: (slug: string) =>
    apiGet<{ posts: Record<string, unknown>[] }>(`${BASE}/series/${slug}/posts`),
};
